<template>
    <div class="article-main" v-if="relatedStories.count>0">
        <div class="inner-wrap">
            <h4 class="cont-tit">연관 이야기자료 (<span class="point">{{relatedStories.count}}</span>)</h4>
            <section class="list-box">
                <ul class="list card">
                    <related-story-item
                        v-for="story in relatedStories.stories"
                        :key="story.id"
                        :story="story"
                        :theme="story.theme_uri"
                    ></related-story-item>
                </ul>
            </section>
            <div class="btn-wrap" v-show=" relatedStories.count>3 ">
                <button
                    id="btn_more_related_stories"
                    class="btn btn-color"
                    @click="moreRelatedStory"
                >
                    더보기
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import RelatedStoryItem from '../StoryList/StoryItem.vue';

export default {
    components: {
        RelatedStoryItem // <related-story-item> // 유사 이야기자료 아이템
    },
    props: {
        theme: { type: String },
        relatedStories: { type: Array|Object }, // 유사 이야기자료 목록
    },
    // created(){
    //     console.log(this.relatedStories.count);
    // },
    methods: {
        // 더보기 버튼 눌렀을 때
        moreRelatedStory() {
            $('.detail .article-main .list-box .card > li').css('display', 'block');
            $('#btn_more_related_stories').css('display', 'none');
        }
    }
}
</script>